module.exports = __webpack_public_path__ + "static/1302437997.3e42149d.jpg";